import { render, staticRenderFns } from "./resource-edit.vue?vue&type=template&id=13a3b3d1&"
import script from "./resource-edit.vue?vue&type=script&lang=js&"
export * from "./resource-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports